// Single source of truth for the frontend build version.
// Displayed in the sidebar footer to diagnose stale-cache issues.
export const APP_VERSION = "2.5.0";
export const APP_BUILD_DATE = "2026-02-12";
